import axios from 'axios'
import { Message } from 'element-ui'
import { handleLockLogin, getActiveCheckType } from '@/utils/common'
import { stopUserStatusPolling } from '@/utils/userStatusPoll'
// ================= 基础配置 =================
// const baseURL = process.env.NODE_ENV === 'production'
//   ? process.env.VUE_APP_BASE_API
//   : '/api'
const baseURL = process.env.VUE_APP_BASE_API;

const request = axios.create({
  baseURL,
  timeout: 10*60*1000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

// 是否在登录页
function isLoginPage() {
  return window.location.pathname.includes('/login')
}

// 是否抢单大厅（仅该页接口需要 check_type）
function isQuotationHallPage() {
  return window.location.pathname.includes('/quotationHall')
}

// 抢单大厅内不需要自动注入 check_type 的接口（黑名单）
const QUOTATION_HALL_NO_CHECK_TYPE_APIS = [
  '/get_user_status',
  '/get_user_info',
  '/ajax_set_sound',
  '/ajax_get_user_check_types',
  '/ajax_get_check_types',
  '/ajax_set_check_types',
  '/ajax_get_orders', // 页面按当前产品 Tab 自行传入
  '/logout',
]

function shouldInjectCheckType(config) {
  if (!isQuotationHallPage()) return false
  const url = config.url || ''
  return !QUOTATION_HALL_NO_CHECK_TYPE_APIS.some(path => url.includes(path))
}

// 统一处理未登录
function handleUnauthorized() {
  stopUserStatusPolling()
  localStorage.removeItem('token');
  localStorage.removeItem('userInfo');
  localStorage.removeItem('rulesAgreed');
  localStorage.removeItem('needsBrandSetup');
  localStorage.removeItem('inviteCodePending');
  localStorage.removeItem('userProducts');
  localStorage.removeItem('activeProductType');
  localStorage.removeItem('active_order_type');
  localStorage.removeItem('theme');
  if (!isLoginPage()) {
    Message.error('Your login has expired, please log in again')

    setTimeout(() => {
      window.location.href = '/login'
    }, 800)
  }
}

// ================= 请求拦截器 =================
request.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')

    // 未登录拦截（排除登录页）
    if (!isLoginPage() && !token) {
      handleUnauthorized()
      return Promise.reject(new Error('Login required'))
    }

    // 注入 token
    if (token) {
      config.headers['AUTH'] = token
    }
    // ================= 仅抢单大厅页注入 check_type =================
    if (shouldInjectCheckType(config)) {
      const checkType = getActiveCheckType()

      // FormData
      if (config.data instanceof FormData) {
        config.data.set('check_type', checkType)
      }

      // 普通 POST
      else if (config.method === 'post') {
        config.data = {
          ...(config.data || {}),
          check_type: checkType
        }
      }

      // GET
      if (config.method === 'get') {
        config.params = {
          ...config.params,
          check_type: checkType,
          _t: Date.now()
        }
      }
    }

    // GET 防缓存（非大厅页）
    else if (config.method === 'get') {
      config.params = {
        ...config.params,
        _t: Date.now()
      }
    }

    return config
  },
  error => Promise.reject(error)
)

// ================= 响应拦截器 =================
request.interceptors.response.use(
  async response => {
    const { config, data, headers } = response

    const isDownload =
      config.responseType === 'blob' ||
      config.returnFullResponse === true ||
      config.url?.includes('/download_')

    // ================= 下载请求处理 =================
    if (isDownload) {
      const contentType = headers['content-type'] || ''

      // 如果返回 JSON（说明是错误）
      if (contentType.includes('application/json') || contentType.includes('text/html')) {
        try {
          const text = await response.data.text()
          const json = JSON.parse(text)

          if (json.info === 'Login required') {
            handleUnauthorized()
            return Promise.reject(json)
          }
         
          if (json.data?.account_disabled === 1) {
            handleLockLogin(json.info)
            return Promise.reject(json)
          }

          return Promise.reject(json)
        } catch (e) {
          Message.error('File download failed')
          return Promise.reject(e)
        }
      }

      return response
    }

    // ================= 普通接口处理 =================
    const res = data
    // 登录失效
    if (res.status === false && res.info === 'Login required') {
      handleUnauthorized()
      return Promise.reject(res)
    }

    if (res.data?.account_disabled === 1) {
      handleLockLogin(res.info)
      return Promise.reject(res)
    }

    return res
  },

  // ================= 错误处理 =================
  error => {
    const status = error.response?.status
    if (status === 401) {
      handleUnauthorized()
      return Promise.reject(error)
    }

    if (!isLoginPage()) {
      // if (status) {
      //   // 处理500 等
      //   // Message.error(`请求失败（${status}）`)
      // } else if (error.request) {
      //   // Message.error('Network Error')
      // } else {
      //   // Message.error('请求配置错误')
      // }
    }

    return Promise.reject(error)
  }
)

// ================= 封装方法 =================

// GET
export function get(url, params = {}, config = {}) {
  return request({
    method: 'get',
    url,
    params,
    ...config
  })
}

// POST
export function post(url, data = {}, config = {}) {
  return request({
    method: 'post',
    url,
    data,
    ...config
  })
}

// 上传
// export function upload(url, file, config = {}) {
//   const formData = new FormData()
//   formData.append('file', file)

//   return request({
//     method: 'post',
//     url,
//     data: formData,
//     headers: {
//       'Content-Type': 'multipart/form-data'
//     },
//     ...config
//   })
// }

// // 下载
// export function download(url, params = {}, config = {}) {
//   return request({
//     method: 'get',
//     url,
//     params,
//     responseType: 'blob',
//     ...config
//   })
// }

export default request